import {NgModule} from '@angular/core';
import {SegmentAnnotatorComponent} from '@ispm-client/modules/segments/components/segment-annotator/segment-annotator.component';
import {ImageSegmentComponent} from './components/segment/image-segment.component';
import {AggregatorModule} from '@ispm-client/modules/aggregator/aggregator.module';
import {SharedModule} from '@ispm/shared/shared.module';
import {WidgetsModule} from '@ispm-client/modules/widgets';
import {SegmentService} from '@ispm-client/modules/segments/services/segments.service';
import {LegendComponent} from '@ispm-client/modules/segments/components/legend/legend.component';
import {TranslateModule} from '@ngx-translate/core';
import {PanCancerModule} from '@ispm-client/modules/pan-cancer';
import {CoreModule} from '@ispm/core/core.module';
import {SegmentFindingsTableComponent} from '@ispm-client/modules/segments/components/segment-findings-table/segment-findings-table.component';
import {DynamicFormModule} from '@ispm/dynamic-form/dynamic-form.module';
import {FindingsService} from '@ispm-client/modules/segments/services/findings.service';
import {Anatomy3dViewerComponent} from './components/anatomy3d-viewer/anatomy3d-viewer.component';
import {ModelViewerService} from "@ispm-client/modules/segments/services/anatomy3dViewer.service";
import {ModelViewerComponent} from './components/model-viewer/model-viewer.component';
import {CommonModule} from "@angular/common";
import { DialogModule } from 'primeng/dialog';

@NgModule({
    imports: [
        CommonModule,
        AggregatorModule,
        SharedModule,
        WidgetsModule,
        TranslateModule,
        PanCancerModule,
        CoreModule,
        DynamicFormModule,
        DialogModule
    ],
    declarations: [SegmentAnnotatorComponent, ImageSegmentComponent, LegendComponent, SegmentFindingsTableComponent, Anatomy3dViewerComponent, ModelViewerComponent],
    providers: [SegmentService, FindingsService, ModelViewerService],
    exports: [SegmentAnnotatorComponent, ImageSegmentComponent, LegendComponent, SegmentFindingsTableComponent, ModelViewerComponent]
})
export class SegmentsModule {
}
